import { render, staticRenderFns } from "./RecordingCardCastShimmer.vue?vue&type=template&id=701a1cfe&scoped=true&"
import script from "./RecordingCardCastShimmer.vue?vue&type=script&lang=js&"
export * from "./RecordingCardCastShimmer.vue?vue&type=script&lang=js&"
import style0 from "./RecordingCardCastShimmer.vue?vue&type=style&index=0&id=701a1cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a1cfe",
  null
  
)

export default component.exports